












































import { Vue, cookies, servicesURL, webClientID, requestHeaders, getCookie, headers } from '../../constants/constants'
import ReviewCard from '../review-card/ReviewCard.vue';
import {
  staticContent
} from '../../localisation/detect-lang';
import axios from 'axios';

export default Vue.extend({
	name: 'restaurant-reviews',
	components: {
		'review-card': ReviewCard
	},
	props: {
		reviewsData: {
			required: true,
			type: Object
    },
    shortCode: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      reviews: [],
      count: null,
      page: 1,
      pageSize: 20,
      loadingReviews: false,
      staticContent,
      reviewSection:false
    }
  },
  computed: {
    nextPage () {
      return this.reviews.length < this.count
      ? this.page + 1
      : null
    },
    profile(){
      return this.$root.profile
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    toggleReview(){
      this.reviewSection=!this.reviewSection
      if(!(this.profile && this.profile.data.profile)){
      console.log(this.profile)

          this.$root.modalToggler("login-signup-modal", "show");

      }
    },
    initData () {
      this.reviews = this.reviewsData.data
      this.page = this.reviewsData.page,
      this.count = this.reviewsData.count
    },
    loadMoreReviews () {
      const params = `page=${this.nextPage}&pageSize=${this.pageSize}`;
      this.loadingReviews = true;
      axios({
        method: "GET",
        url: servicesURL.restaurant.reviews(this.shortCode, params),
        headers
      })
      .then(res => {
        this.page = res.data.page;
        this.count = res.data.count;
        this.reviews = this.reviews.concat(res.data.data);

        //complete
        this.loadingReviews = false;
      })
      .catch(error => {
          console.log("error", error)
      });
    }
  }
})
